import { render, staticRenderFns } from "./contact-list-header.vue?vue&type=template&id=637d57fe&scoped=true&"
import script from "./contact-list-header.vue?vue&type=script&lang=js&"
export * from "./contact-list-header.vue?vue&type=script&lang=js&"
import style0 from "./contact-list-header.vue?vue&type=style&index=0&id=637d57fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637d57fe",
  null
  
)

export default component.exports